import { useQuery } from '@tanstack/react-query'

import { catalogApi, catalogKeys } from '../../lib'

export function useProductAttributes(productSku: string) {
  return useQuery({
    queryKey: catalogKeys.productAttributes(productSku),
    queryFn: async () => {
      const data = await catalogApi.getProductAttributes(productSku)
      return data.products.items[0] || null
    },
    enabled: !!productSku,
  })
}
